import React from 'react';
import clsx from 'clsx';
import {type UseFormReturn} from 'react-hook-form';
import {ReactHookFormTextField} from '@netx/core-components/Form/TextField';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {CartsSavedManagerLabel} from '../../locales';
import {type ISavedCartFormValues} from '../../schema';
import {
	getSavedCartManagerUtilityClass,
	SAVED_CART_MANAGER_NAME,
	savedCartManagerClasses,
	type SavedCartManagerClasses,
} from './savedCartManagerClasses';

type SavedCartManagerOwnerState = WithClasses<SavedCartManagerClasses>;

const useUtilityClasses = (state: SavedCartManagerOwnerState) => {
	const {classes} = state;
	const slots = {
		root: ['root'],
		inputWrapper: ['textFieldWrapper'],
	};
	return composeClasses(slots, getSavedCartManagerUtilityClass, classes);
};

const SavedCartManagerRoot = styled('div', {
	name: SAVED_CART_MANAGER_NAME,
	slot: 'Root',
})(({theme}) => ({
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
	flex: '1 1 auto',
	minHeight: 0,
}));

const InputWrapper = styled('div', {
	name: SAVED_CART_MANAGER_NAME,
	slot: 'InputWrapper',
})(({theme}) => ({
	display: 'flex',
	flexDirection: 'column',
	padding: '8px 16px',
}));

const ReactHookFormTextFieldStyled = styled(ReactHookFormTextField)(
	({theme}) => ({
		marginBottom: theme.spacing(1.5),
	}),
) as typeof ReactHookFormTextField;

export interface SavedCartManagerProps
	extends WithClasses<SavedCartManagerClasses> {
	form: UseFormReturn<ISavedCartFormValues>;
	loading?: boolean;
}

/**
 * `SavedCartManager` is a component for creating or editing system groups,
 * supporting user addition and removal with autocomplete functionality.
 */
export const SavedCartManager = ({
	classes: _classes,
	className,
	form,
	loading,
	...props
}: SavedCartManagerProps) => {
	const ownerState: SavedCartManagerOwnerState = {
		classes: _classes,
		className,
	};
	const classes = useUtilityClasses(ownerState);

	return (
		<SavedCartManagerRoot className={clsx(classes.root, className)} {...props}>
			<InputWrapper>
				<ReactHookFormTextFieldStyled
					control={form.control}
					disabled={loading}
					fullWidth
					label={CartsSavedManagerLabel.TITLE}
					name="title"
					required
				/>
			</InputWrapper>
		</SavedCartManagerRoot>
	);
};
